import { findFirstFocusable } from '.';

/**
 * Set focus to the first focusable element in the given view
 * @param name The name of the view to set focus to
 */
export const setFocus = (name: string): void => {
  const el = document.getElementById(`view-${name}`);
  if (el) {
    const firstFocusable = findFirstFocusable(el);
    firstFocusable?.focus({ preventScroll: true });
  }
};

export default setFocus;
